
import { ClientMailNotifications, ServicePackEmailNotificationState } from "@/models/client-mail-notifications";
import { Company } from "@/models/company";
import { CompanyService } from "@/services/company-service";
import { ISelectItem } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";
export default Vue.extend({
	data(){
		return {
			state: null as null | ClientMailNotifications
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		spExpirationStateText():string{
			if (!this.state) return "";
			if (this.state.servicePackEmail == ServicePackEmailNotificationState.NoMailSent){
				return "Geen herinerringen verstuurd";
			}else if (this.state.servicePackEmail == ServicePackEmailNotificationState.InitialReminderSent) {
				return "Initiele herinerringsmail is verstuurd";
			}else if (this.state.servicePackEmail == ServicePackEmailNotificationState.HasBeenBought){
				return "Service pack is aangekocht";
			}
			return "Herinneringsmail is verstuurd";
		},
		spExpirationActions():ISelectItem<string>[]{
			return [
				{
					text: "Verstuur initieele mail",
					value: "sendInitialSpExpirationMail"
				},
				{
					text: "Verstuur mail",
					value: "sendSpExpirationMail"
				}
			] as ISelectItem<string>[];
		}
	},
	methods: {
		async fetchState(){
			this.state = await CompanyService.getClientMailNotificationStates(this.company);
		},
		handle(funcName:string){
			(this as any)[funcName]();
		},
		async sendInitialSpExpirationMail(){
			await CompanyService.sendInitialSpExpiryMail(this.company);
			await this.fetchState();
		},
		async sendSpExpirationMail(){
			await CompanyService.sendSpExpiryMail(this.company);
			await this.fetchState();
		},
	},
	async created(){
		this.fetchState();
	},
	components: {
		AppCompanyEditWrapper
	}
});
